import config from 'garaje/config/environment';
import Mirage, { Collection } from 'miragejs';
import { timeout } from 'ember-concurrency';

export default function () {
  this.urlPrefix = config.badgeLogApiHost;

  this.get('a/badge-log/v1/plugin-install-statuses', function (schema, request) {
    const { queryParams } = request;
    let locationIds = null;

    if (queryParams['filter[location-ids]']) {
      locationIds = queryParams['filter[location-ids]'].split(',');
    }

    if (!locationIds) {
      return {
        data: [],
      };
    }

    const responseBody = locationIds.flatMap((locationId) => {
      const pluginInstalls = schema.pluginInstalls.where({ locationId: locationId });
      // debugger;
      if (pluginInstalls.models.length === 0) {
        return [];
      }

      return pluginInstalls.models.map((pluginInstall) => ({
        relationships: {
          'plugin-install': {
            data: {
              id: pluginInstall.id,
              type: 'plugin-installs',
            },
          },
          location: {
            data: {
              id: locationId,
              type: 'locations',
            },
          },
        },
        attributes: {
          'last-successful-event': new Date().toISOString(),
          'current-status': 'FAILURE',
        },
        id: `${locationId}-${pluginInstall.id}`,
        type: 'plugin-install-statuses',
      }));
    });

    return {
      data: responseBody,
    };
  });
  this.get('a/badge-log/v1/access-events', async function (schema, request) {
    const { queryParams } = request;

    // Start with all access events
    let accessEvents = schema.accessEvents.all();

    // Apply location filter
    if (queryParams['filter[location-ids]']) {
      const locationIds = queryParams['filter[location-ids]'].split(',');
      accessEvents = accessEvents.filter((event) => locationIds.includes(event.locationId));
    }

    // Apply time range filters
    if (queryParams['filter[start-time]']) {
      const startTime = new Date(queryParams['filter[start-time]']);
      accessEvents = accessEvents.filter((event) => new Date(event.messageTimestamp) >= startTime);
    }

    if (queryParams['filter[end-time]']) {
      const endTime = new Date(queryParams['filter[end-time]']);
      accessEvents = accessEvents.filter((event) => new Date(event.messageTimestamp) <= endTime);
    }

    // Convert to array for sorting if needed
    let results = accessEvents.models;

    // Apply sorting
    if (queryParams['sort']) {
      const sortFields = queryParams['sort'].split(',');
      results.sort((a, b) => {
        for (const field of sortFields) {
          const isDescending = field.startsWith('-');
          const actualField = isDescending ? field.slice(1) : field;

          const aValue = a[actualField] || a.attrs[actualField];
          const bValue = b[actualField] || b.attrs[actualField];

          if (aValue < bValue) return isDescending ? 1 : -1;
          if (aValue > bValue) return isDescending ? -1 : 1;
        }
        return 0;
      });
    }

    // Apply pagination
    const limit = parseInt(queryParams['page[limit]']) || 50;
    const offset = parseInt(queryParams['page[offset]']) || 0;
    results = results.slice(offset, offset + limit);

    const collection = new Collection('access-events', results);

    // Serialize and return the response
    const serialized = this.serializerOrRegistry.serialize(collection, request);
    serialized.meta = { 'total-count': accessEvents.models.length };
    await timeout(2000);
    return new Mirage.Response(200, {}, serialized);
  });
}
